import { i18nFilter } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import OnOffSwitchRegionalsContainer from "app/pages/industry-analysis/players/market-shares/OnOffSwitchRegionalsContainer";
import { BannerTitle, BannerTitleContainer, StyledBanner, StyledIcon } from "app/pages/industry-analysis/players/market-shares/StyledComponent";
import { PlainTooltip } from "@similarweb/ui-components";

type Props = {
    toggleRegionals(isRegionalsEnabled: boolean): void;
    isRegionalsEnabled: boolean;
    isDisabled: boolean;
    tooltipText?: string;
};

const RegionalsToggleBanner = ({ toggleRegionals, isRegionalsEnabled, isDisabled, tooltipText }: Props) => {
    const banner = (
        <StyledBanner
            isDisabled={isDisabled}
            title={
                <BannerTitleContainer isDisabled={isDisabled}>
                    <div>
                        <I18n
                            element={BannerTitle}
                            translatable={{ key: "website.analysis.regionals.toggle.banner.title" }}
                        />
                    </div>
                </BannerTitleContainer>
            }
            CustomIcon={
                <StyledIcon
                    isDisabled={isDisabled}
                    iconName="regionals-world"
                    size="sm"
                />
            }
            CustomButton={
                <OnOffSwitchRegionalsContainer
                    isDisabled={isDisabled}
                    toggleRegionals={toggleRegionals}
                    isRegionalsEnabled={isRegionalsEnabled}
                    onOffSwitchLabel={i18nFilter()("website.analysis.regionals.toggle.label")}
                />
            }
        />
    );

    if (tooltipText) {
        return (
            <PlainTooltip
                placement="top"
                tooltipContent={tooltipText}
            >
                <span>{banner}</span>
            </PlainTooltip>
        );
    }

    return banner;
};

export default RegionalsToggleBanner;
